var frfr = {
	"coupon-callout": {
	"coupon-code": "Code",
	"coupon-message-with-price": "Seulement {{ price }}",
	"coupon-expiry-message": "Valable jusqu’au {{ Date }}.",
	"code-at-checkout": "Saisissez le code en fin de commande. Offre non cumulable avec d’autres codes, promotions ou réductions.",
	"cancel-icon": "Annuler",
	"info-icon": "Voir les détails",
	"check-icon": "Appliqué",
	"promo-code": "Code promo",
	"coupon-callout-popover": "Pop up message bon de réduction"
}
};

export { frfr as default };
//# sourceMappingURL=src-localization-texts-fr-fr.json.js.map
